import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {Provider} from "react-redux";
import {store} from "./store";
import './css/App.css'
import axios from "axios";

axios.defaults.baseURL = window.location.origin + process.env.REACT_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.withCredentials = true
const token = localStorage.getItem('jwt')
axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);